<template>
  <div class="work_wrap" id="targetbox">
    <div class="work_back flex">
      <span class="work_backtext" @click="backJob">< 返回上一步</span>
      <div class="work_backicon" @click="backJob">
        <span class="el-icon-arrow-left"></span>
        <span style="font-size: 16px;">返回上一步</span>
      </div>
    </div>
    <div class="font18 work_font1">{{jobDetail.jobName}}</div>
    <ul class="work_requirement">
      <li class="flex">
        <div class="requirement_left">学历要求：</div>
        <div class="requirement_right">{{jobDetail.educationName}}以上</div>
      </li>
      <li class="flex">
        <div class="requirement_left">招聘人数：</div>
        <div class="requirement_right">{{jobDetail.jobPeopleCount}}人</div>
      </li>
      <li class="flex">
        <div class="requirement_left">工作经验：</div>
        <div class="requirement_right">{{jobDetail.jobExperience}}</div>
      </li>
      <li class="flex">
        <div class="requirement_left">工资待遇：</div>
        <div class="requirement_right">{{jobDetail.jobSalaryMin}}K-{{jobDetail.jobSalaryMax}}K</div>
      </li>
      <li class="flex">
        <div class="requirement_left">发布日期：</div>
        <div class="requirement_right">{{jobDetail.updateTime}}</div>
      </li>
    </ul>
    <div class="font18 work_font2">职位描述</div>
    <div class="font18 work_font1">岗位职责：</div>
    <div class="work_content" v-html="jobDetail.jobDesc"></div>
    <div class="font18 work_font1">任职资格：</div>
    <div class="work_content" v-html="jobDetail.jobCondition"></div>
    <div class="delivery_down">
      <div class="rightaway_delivery" @click="deliveryJob">立即投递</div>
    </div>
  </div>
</template>

<script>
	import { jobinfoemploymentapi } from "@/api/apilist/commonApi";
	import { zyType, experienceType } from "@/utils";
  export default {
    data() {
      return {
		jobDetail: {}
      };
    },
    props: {
		jobInfo: {
			type: Object,
			default: ()=>{}
		},
		backValue: {
			type: Number,
			default: 0,
		}
    },
    created() {
      this.$nextTick(() => {
        setTimeout(() => {
          let targetbox = document.getElementById('targetbox');
          document.documentElement.scrollTop = targetbox.offsetTop;
        },100)
      })
      this.getjobinfoemployment();
    },
    methods:{
		backJob(){
			this.$emit('backJob', this.backValue)
		},
		deliveryJob(){
			this.$emit('deliveryJob')
		},
		getjobinfoemployment() {
			jobinfoemploymentapi(this.jobInfo.jobId).then(res=>{
				res.data.updateTime = res.data.updateTime.slice(0, 10);
				res.data.educationName = zyType(res.data.jobEducation);
        res.data.jobExperience = experienceType(res.data.jobYearMin, res.data.jobYearMax);
        res.data.jobSalaryMin = res.data.jobSalaryMin/1000;
        res.data.jobSalaryMax = res.data.jobSalaryMax/1000;
				this.jobDetail = res.data;
			})
		},
    }
  }
</script>

<style scoped lang="less">
	@media screen and (max-width: 480px){
    .work_content{font-size: 16px;}
		.work_back{
			.work_backicon{font-size: 20px;padding: 10px 30px 10px 0px;margin-left: -5px;}
			.work_backtext{display: none;}
		}
		.font18{font-size: 16px;}
		.work_wrap{
		  padding-top: 10px;
		  font-size: 14px;
		}
		.work_font1{margin: 10px 0 4px;}
		.work_requirement{line-height: 40px;
			li{border-bottom: 1px solid #F2F2F2;
			  .requirement_right{flex: 1;}
			}
			li:last-child{border: none;}
		}
		.requirement_left{width: 120px;}
		.work_font2{border-bottom: 1px solid #F2F2F2;margin-top: 20px;padding-bottom: 14px;}
		.rightaway_delivery{
		  width: 100%;
		  height: 40px;
		  line-height: 40px;
		  color: #fff;
		  text-align: center;
		  background-color: #DCC691;
		  border-radius: 5px;
		  cursor: pointer;
		  font-size: 14px;
		  font-weight: bold;
		}
		.delivery_down{margin: 20px 0 50px;}
	}
	@media screen and (min-width: 481px){
		.work_back{
			.work_backicon{display: none;}
		}
		.font18{font-size: 18px;}
		.work_wrap{
		  padding-top: 100px;
		  font-size: 16px;
		}
		.work_font1{margin: 50px 0 14px;}
		.work_requirement{line-height: 64px;
			li{border-bottom: 1px solid #C2C2C2;
			  .requirement_right{flex: 1;}
			}
			li:last-child{border: none;}
		}
		.requirement_left{width: 180px;}
		.work_font2{border-bottom: 1px solid #C2C2C2;margin-top: 46px;padding-bottom: 14px;}

		.rightaway_delivery{
		  width: 120px;
		  height: 40px;
		  line-height: 40px;
		  color: #fff;
		  text-align: center;
		  background-color: #DCC691;
		  border-radius: 20px;
		  cursor: pointer;
		  font-weight: bold;
		  font-size: 18px;
		}
		.delivery_down{margin: 20px 0 105px;}
	}
  .font18{font-weight: bold;}
  .work_wrap{

    .work_content{line-height: 50px;}
    .work_back{
      color: #D9BF81;
      cursor: pointer;
    }
  }
</style>
